/* Indirookh own apps: product reviews (filter, sort, show more, write, photos), homepage reviews strip, Instagram feed. */
(function () {
  function openDialog(d) { if (d && !d.open) { d.showModal ? d.showModal() : d.setAttribute('open', ''); } }
  function closeDialog(d) { if (d && d.open) { d.close ? d.close() : d.removeAttribute('open'); } }
  function wireDialog(d) {
    if (!d) return;
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-ir-close]')) closeDialog(d);   // backdrop or close button
    });
  }

  /* ---------- Product reviews ---------- */
  var rev = document.querySelector('[data-ir-reviews]');
  if (rev) {
    var list = rev.querySelector('[data-ir-list]'), more = rev.querySelector('[data-ir-more]'),
        empty = rev.querySelector('[data-ir-empty]'), sort = rev.querySelector('[data-ir-sort]'),
        modal = rev.querySelector('[data-ir-modal]'), lightbox = rev.querySelector('[data-ir-lightbox]');
    var PAGE = 6, shown = PAGE, filter = 'all';
    var items = list ? Array.prototype.slice.call(list.children) : [];
    items.forEach(function (li, i) { li.dataset.i = i; });   // server order = most useful

    function matches(li) {
      if (filter === 'all') return true;
      if (filter === 'photos') return li.dataset.ph === '1';
      if (filter === 'text') return li.dataset.tx === '1';
      return li.dataset.r === filter;
    }
    function render() {
      if (!list) return;
      var n = 0, total = 0;
      items.forEach(function (li) {
        var ok = matches(li);
        if (ok) total++;
        li.hidden = !(ok && n < shown);
        if (ok && n < shown) n++;
      });
      if (more) more.hidden = total <= shown;
      if (empty) empty.hidden = total > 0;
    }
    function setFilter(f) {
      filter = filter === f && f !== 'all' ? 'all' : f;
      shown = PAGE;
      rev.querySelectorAll('[data-ir-filter]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.irFilter === filter); });
      render();
    }
    rev.addEventListener('click', function (e) {
      var f = e.target.closest('[data-ir-filter]');
      if (f) { setFilter(f.dataset.irFilter); return; }
      if (e.target.closest('[data-ir-more]')) { shown += PAGE; render(); return; }
      if (e.target.closest('[data-ir-write]')) { openDialog(modal); return; }
      var ph = e.target.closest('[data-ir-photo]');
      if (ph && lightbox) { lightbox.querySelector('img').src = ph.dataset.irPhoto + '&width=1200'; openDialog(lightbox); }
    });
    if (sort) sort.addEventListener('change', function () {
      var v = sort.value;
      items.sort(function (a, b) {
        if (v === 'high' && a.dataset.r !== b.dataset.r) return b.dataset.r - a.dataset.r;
        if (v === 'low' && a.dataset.r !== b.dataset.r) return a.dataset.r - b.dataset.r;
        if (v === 'useful') return a.dataset.i - b.dataset.i;
        return a.dataset.d < b.dataset.d ? 1 : a.dataset.d > b.dataset.d ? -1 : 0;
      });
      items.forEach(function (li) { list.appendChild(li); });
      shown = PAGE; render();
    });
    wireDialog(modal); wireDialog(lightbox);
    // Back from the contact form: Shopify reloads with ?contact_posted=true (or errors) - show the result in the dialog
    if (modal && (modal.querySelector('[data-ir-posted]') || modal.querySelector('.ir-rf__err'))) {
      openDialog(modal);
      if (history.replaceState) history.replaceState(null, '', location.pathname + '#ir-reviews');
    }
    render();
  }

  /* ---------- Homepage reviews strip ---------- */
  document.querySelectorAll('[data-ir-hr]').forEach(function (s) {
    var track = s.querySelector('[data-ir-track]');
    function step(dir) {
      var card = track.firstElementChild; if (!card) return;
      track.scrollBy({ left: dir * (card.getBoundingClientRect().width + 18), behavior: 'smooth' });
    }
    s.querySelector('[data-ir-prev]').addEventListener('click', function () { step(-1); });
    s.querySelector('[data-ir-next]').addEventListener('click', function () { step(1); });
  });

  /* ---------- Instagram feed ---------- */
  document.querySelectorAll('[data-ir-ig]').forEach(function (s) {
    var box = s.querySelector('[data-ir-postbox]');
    wireDialog(box);
    s.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ir-post]'); if (!t || !box) return;
      box.querySelector('.ir-post__media img').src = t.dataset.img + '&width=1000';
      box.querySelector('.ir-post__media img').alt = t.dataset.cap;
      box.querySelector('.ir-post__cap').textContent = t.dataset.cap;
      box.querySelector('.ir-post__reel').hidden = t.dataset.kind !== 'reel';
      var shop = box.querySelector('.ir-post__shop'), ig = box.querySelector('.ir-post__ig');
      ig.href = t.dataset.link;
      ig.textContent = t.dataset.kind === 'reel' ? 'Watch on Instagram' : 'View on Instagram';
      if (t.dataset.shop) { shop.href = t.dataset.shop; shop.hidden = false; } else { shop.hidden = true; }
      openDialog(box);
    });
  });
})();

/* Homepage "Shop by" tabs + announcement rotation */
(function () {
  document.querySelectorAll('[data-ir-tabs]').forEach(function (s) {
    var tabs = s.querySelectorAll('[data-ir-tab]');
    function show(g, focus) {
      tabs.forEach(function (t) {
        var on = t.dataset.irTab === g;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      s.querySelectorAll('[data-ir-panel]').forEach(function (p) { p.hidden = p.dataset.irPanel !== g; });
    }
    tabs.forEach(function (t, i) {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
      t.addEventListener('click', function () { show(t.dataset.irTab); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); show(tabs[(i + d + tabs.length) % tabs.length].dataset.irTab, true); }
      });
    });
  });
  document.querySelectorAll('[data-ir-ann]').forEach(function (a) {
    var m = a.querySelectorAll('.ir-ann__msg'), i = 0, paused = false;
    if (m.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    a.addEventListener('mouseenter', function () { paused = true; });
    a.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      m[i].classList.remove('is-on'); i = (i + 1) % m.length; m[i].classList.add('is-on');
    }, 4000);
  });
})();

/* Footer folds open on desktop, closed on phone; sections fade in once */
(function () {
  var cols = document.querySelectorAll('[data-ir-ftcol]');
  function setCols() { var wide = window.matchMedia('(min-width: 768px)').matches; cols.forEach(function (d) { if (wide) d.open = true; }); }
  setCols(); window.addEventListener('resize', setCols);
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.ir-sb, .ir-val, .ir-hr, .ir-ig, .ir-rev, .watch-buy-section');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) {
    if (el.getBoundingClientRect().top < window.innerHeight) return;   // already on screen: leave as is
    el.classList.add('ir-reveal'); io.observe(el);
  });
})();

/* Find your colour: tabs + colour dots swap photo, name, price, link */
(function () {
  document.querySelectorAll('[data-ir-colour]').forEach(function (s) {
    s.querySelectorAll('[data-ir-ctab]').forEach(function (t) {
      t.addEventListener('click', function () {
        s.querySelectorAll('[data-ir-ctab]').forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        s.querySelectorAll('[data-ir-cpanel]').forEach(function (p) { p.hidden = p.dataset.irCpanel !== t.dataset.irCtab; });
      });
    });
    s.addEventListener('click', function (e) {
      var d = e.target.closest('.ir-col__dot'); if (!d) return;
      var p = d.closest('[data-ir-cpanel]'), img = p.querySelector('.ir-col__media img');
      p.querySelectorAll('.ir-col__dot').forEach(function (x) { x.setAttribute('aria-checked', x === d ? 'true' : 'false'); });
      p.querySelector('[data-ir-ccolour]').textContent = d.dataset.colour;
      p.querySelector('[data-ir-cprice]').textContent = d.dataset.price;
      p.querySelector('[data-ir-cname]').textContent = d.dataset.name;
      p.querySelectorAll('[data-ir-clink]').forEach(function (a) { a.href = d.dataset.url; });
      var n = new Image(); img.classList.add('is-swap');
      n.onload = n.onerror = function () { img.removeAttribute('srcset'); img.src = d.dataset.img; img.classList.remove('is-swap'); };
      n.src = d.dataset.img;
    });
    s.querySelectorAll('.ir-col__dot').forEach(function (d) {   // warm the cache on hover/touch
      ['mouseenter', 'touchstart'].forEach(function (ev) { d.addEventListener(ev, function () { (new Image()).src = d.dataset.img; }, { once: true, passive: true }); });
    });
  });
})();

/* Sliders: load every product photo in a carousel once the carousel is near the screen,
   so swiping never shows white blanks (lazy images otherwise wait until they slide into view). */
(function () {
  var sliders = document.querySelectorAll('.flickity__section, .js-carousel, .swiper');
  if (!sliders.length) return;
  function warm(s) { s.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; }); }
  if (!('IntersectionObserver' in window)) { sliders.forEach(warm); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { warm(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '600px 0px' });
  sliders.forEach(function (s) { io.observe(s); });
})();
